import { ActionTypes } from "../Constant/ActionType.tsx";

export const totalNotificationAction = (total:Number) => {
  return {
    type: ActionTypes.TOTAL_NOTIFICATION,
    payload: total,
  };
};

export const setTotalNotification = (payload:Object) => {
  return {
    type: ActionTypes.SET_NOTIFICATION,
    payload: payload
  }
}

export const incrementIndexForNotification = (num: Number) => {
  return {
    type: ActionTypes.INCREMENT,
    num: num,
  }
}
